import React, { useState, useEffect, useContext } from 'react'
import { Table, Button, notification } from 'antd'
import { PlusOutlined, EditOutlined } from '@ant-design/icons'
import PrioritySlaConfigModal from './PriorityModal'
import { useQuery, useMutation } from '@apollo/react-hooks'
import { GET_PRIORITY_SLA_CONFIGS } from '../graphql/Queries'
import {
  CREATE_PRIORITY_SLA_CONFIG,
  UPDATE_PRIORITY_SLA_CONFIG,
  // DELETE_PRIORITY_SLA_CONFIG,
} from '../graphql/Mutations'
import { AppContext } from 'AppContext'
import { canUserEdit, canUserAdd } from 'utils/User'

const PAGE_SIZE = 10

const PrioritySlaConfigTable = () => {
  const { state: { currentUser, userPermissions, isClient } = {} } = useContext(AppContext) || {}
  const canEdit = canUserEdit(userPermissions || currentUser, isClient)
  const canAdd = canUserAdd(userPermissions || currentUser, isClient)

  const { data, loading, refetch } = useQuery(GET_PRIORITY_SLA_CONFIGS)
  const [createPrioritySlaConfig] = useMutation(CREATE_PRIORITY_SLA_CONFIG)
  const [updatePrioritySlaConfig] = useMutation(UPDATE_PRIORITY_SLA_CONFIG)
  // const [deletePrioritySlaConfig] = useMutation(DELETE_PRIORITY_SLA_CONFIG)

  const [modalVisible, setModalVisible] = useState(false)
  const [editingPrioritySlaConfig, setEditingPrioritySlaConfig] = useState(null)
  const [currentPage, setCurrentPage] = useState(1)
  const [prioritySlaConfigs, setPrioritySlaConfigs] = useState([])

  useEffect(() => {
    if (data && data.getPrioritySlaConfigs) {
      setPrioritySlaConfigs(data.getPrioritySlaConfigs)
    }
  }, [data])

  const handleAdd = () => {
    if (!canAdd) return
    setEditingPrioritySlaConfig(null)
    setModalVisible(true)
  }

  const handleEdit = (record) => {
    if (!canEdit) return
    setEditingPrioritySlaConfig(record)
    setModalVisible(true)
  }

  // const handleDelete = async (id) => {
  //   if (!canDelete) return
  //   try {
  //     await deletePrioritySlaConfig({ variables: { id } })
  //     notification.success({ message: 'PrioritySlaConfig deleted' })
  //     refetch()
  //   } catch (err) {
  //     notification.error({ message: 'Delete failed' })
  //   }
  // }

  const handleModalOk = async (values) => {
    if (editingPrioritySlaConfig && !canEdit) return
    if (!editingPrioritySlaConfig && !canAdd) return
    try {
      if (editingPrioritySlaConfig) {
        await updatePrioritySlaConfig({
          variables: { id: editingPrioritySlaConfig.id, data: values },
        })
        notification.success({ message: 'PrioritySlaConfig updated' })
      } else {
        await createPrioritySlaConfig({ variables: { data: values } })
        notification.success({ message: 'PrioritySlaConfig created' })
      }
      setModalVisible(false)
      refetch()
    } catch (err) {
      notification.error({ message: 'Operation failed' })
    }
  }

  const columns = [
    {
      title: 'Priority',
      dataIndex: 'priorityLevel',
      key: 'priorityLevel',
    },
    {
      title: 'SLA (in Hours)',
      dataIndex: 'slaTime',
      key: 'slaTime',
    },
    ...(canEdit
      ? [
          {
            title: 'Actions',
            key: 'actions',
            render: (_, record) => (
              <>
                <EditOutlined
                  color='primary'
                  style={{ marginRight: 12 }}
                  onClick={() => handleEdit(record)}
                />
                {/* <Popconfirm title='Delete?' onConfirm={() => handleDelete(record.id)}>
                  <DeleteOutlined color='red' />
                </Popconfirm> */}
              </>
            ),
          },
        ]
      : []),
  ]

  // Pagination logic
  const paginatedData = prioritySlaConfigs.slice(
    (currentPage - 1) * PAGE_SIZE,
    currentPage * PAGE_SIZE
  )

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <div style={{ fontWeight: 600, fontSize: 18 }}>
          Priority Sla settings
        </div>
        {canAdd && (
          <Button type='primary' icon={<PlusOutlined />} onClick={handleAdd}>
            Add Priority Sla
          </Button>
        )}
      </div>
      <Table
        columns={columns}
        dataSource={paginatedData}
        rowKey='id'
        loading={loading}
        pagination={{
          current: currentPage,
          pageSize: PAGE_SIZE,
          total: prioritySlaConfigs.length,
          onChange: setCurrentPage,
        }}
      />
      <PrioritySlaConfigModal
        visible={modalVisible}
        onCancel={() => setModalVisible(false)}
        onOk={handleModalOk}
        editingPrioritySlaConfig={editingPrioritySlaConfig}
      />
    </div>
  )
}

export default PrioritySlaConfigTable
